import {
	throttle
} from 'lodash';
import {
	f
} from 'vue-multi-theme';

export default {
	name: "indexView",
	data() {
		return {
			detail: {},
			guide: {},

			showSegIndex: 0,
			showFix: false,
		};
	},
	props: ['parent', 'course_id'],
	watch: {},
	created() {},
	async mounted() {
		await this.getCourseDetail();
		await this.getBuyGuide();

		window.addEventListener('scroll', throttle(this.handleScroll, 200));

	},
	onUpdated() {},
	beforeUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	beforeDestroy() {},
	methods: {
		handleScroll() {
			const scrollTop = window.pageYOffset ||
				document.documentElement.scrollTop ||
				document.body.scrollTop;
			console.log('当前滚动位置:', scrollTop);
			if (scrollTop > 400) {
				this.showFix = true;
			} else {
				this.showFix = false;
			}
		},
		async getCourseDetail() {
			const dataRes = await this.$zkHttp.index$getCourseList({
				course_id: this.course_id
			});
			console.log("dataRes ===> ", dataRes);
			this.detail = dataRes;
		},
		async getBuyGuide() {
			const guideRes = await this.$zkHttp.index$getGuide({
				type: 1
			});
			console.log("guideRes ===> ", guideRes);
			this.guide = guideRes;
		},
		onChangeSegIndex(i) {
			this.showSegIndex = parseInt(i);
		},
		onPlayVideo(e) {
			if (e.play == 1 && e.section_file) {
				console.log("onPlayVideo ===> ", e);

				const newWindow = window.open();
				newWindow.location.href = this.$router.resolve({
					name: 'videoPlay',
					query: {
						url: JSON.stringify(e.section_file)
					}
				}).href;
			}
		},
		async onCollect() {
			const collectRes = await this.$zkHttp.index$collect({
				course_id: this.course_id,
				user_id: this.$store.state.auth.user_id
			});
			console.log("collectRes ===> ", collectRes);
			if (collectRes) {
				this.$message({
					showClose: true,
					message: '收藏成功',
					duration: 3000,
					type: 'success'
				});
			}
		},
		onBindSuccess() {
			this.onBooking();
		},
		async onBooking() {
			if (this.$store.state.auth.is_vip == 1) {
				this.$message({
					showClose: true,
					message: '您是会员，无需订购',
					duration: 3000,
					type: "success", // message type: success/warning/info/error
				});
				return;
			}
			if (!this.$store.state.auth.mobile) {
				this.$refs.tellBindRef.onOpen();
				return;
			}
			if (this.detail.info.price * 100 == 0) {
				// 领取
				const receiveRes = await this.$zkHttp.index$receiveCourse({
					user_id: this.$store.state.auth.user_id,
					course_id: this.detail.info.course_id
				});
				console.log("receiveRes ===> ", receiveRes);
				if (receiveRes) {
					this.$message({
						showClose: true,
						message: '领取成功',
						duration: 3000,
						type: "success", // message type: success/warning/info/error
					});
					this.getCourseDetail();
				}
			} else {
				// 订购
				const putRes = await this.$zkHttp.order$putOrder({
					user_id: this.$store.state.auth.user_id,
					course_id: this.detail.info.course_id
				});
				console.log("putRes ===> ", putRes);
				// id: "6"
				// out_trade_no: "617448694789242394"
				// present_id: ""
				// referred_by: 0
				// total_amount: "198.00"
				// user_id: "15"
				if (putRes && putRes.id) {
					this.onPay(putRes);
				}
			}
		},
		async onPay(e) {
			if (!e.id) return;
			this.$refs.cashierRef.onOpen("order", e.id);
		},
		toTeacherDetail(e) {
			console.log("toTeacherDetail ===> ", e);
			this.$refs.teacherRef.onOpen(e.id);
		},
		toSpecDetail(e) {
			console.log("toSpecDetail ===> ", e);
			this.$router.replace({
				name: 'columnDetail',
				query: {
					parent: 'home',
					special_id: e.id
				}
			});
		}
	},
};